export default "__VITE_ASSET__BTqMSqzP__"